"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newWeekdayValue = exports.newVectorValue = exports.newTimeValue = exports.newStringValue = exports.newRecordValue = exports.newQuoteValue = exports.newNumberValue = exports.newMonthValue = exports.newDateValue = exports.newBooleanValue = void 0;
const decimal_js_1 = __importDefault(require("decimal.js"));
const chrono_1 = require("../chrono");
const exception_1 = require("../exception");
const newBooleanValue = (value = false) => ({
    type: "Boolean",
    value,
});
exports.newBooleanValue = newBooleanValue;
const newDateValue = (year = 1970, month = chrono_1.Month.January, day = 1) => {
    if (!(0, chrono_1.isValidDate)(year, month, day)) {
        throw new exception_1.TypeError("Given date is not valid date.");
    }
    return {
        type: "Date",
        year,
        month,
        day,
    };
};
exports.newDateValue = newDateValue;
const newMonthValue = (value = chrono_1.Month.January) => ({
    type: "Month",
    value,
});
exports.newMonthValue = newMonthValue;
const newNumberValue = (value = 0, unit) => ({
    type: "Number",
    value: value instanceof decimal_js_1.default ? value : new decimal_js_1.default(value),
    unit,
});
exports.newNumberValue = newNumberValue;
const newQuoteValue = (quote) => ({
    type: "Quote",
    quote,
});
exports.newQuoteValue = newQuoteValue;
const newRecordValue = (elements) => ({
    type: "Record",
    elements: new Map(elements),
});
exports.newRecordValue = newRecordValue;
const newStringValue = (value = "") => ({
    type: "String",
    value,
});
exports.newStringValue = newStringValue;
const newTimeValue = (hour = 0, minute = 0, second = 0) => {
    if (!(0, chrono_1.isValidTime)(hour, minute, second)) {
        throw new exception_1.TypeError("Given time is not valid time.");
    }
    return {
        type: "Time",
        hour,
        minute,
        second,
    };
};
exports.newTimeValue = newTimeValue;
const newVectorValue = (elements = []) => ({
    type: "Vector",
    elements: [...elements],
});
exports.newVectorValue = newVectorValue;
const newWeekdayValue = (value = chrono_1.Weekday.Sunday) => ({
    type: "Weekday",
    value,
});
exports.newWeekdayValue = newWeekdayValue;
